

































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import meterModelPo from "@/store/entities/devices/metermodelpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  components: { TreeSelect },
})
export default class CreateMeterModel extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  meterModelPo: meterModelPo = new meterModelPo();
  loading: boolean = false;
  async created() {
    this.areaTree();
    this.getItemDetail();
    this.getPrice();
    this.getSupplier();
    this.meterModelPo.isEnable = 1;
    this.meterModelPo.magnification = 1;
    this.meterModelPo.rateNum = 0;
    this.meterModelPo.isSynch = false;
    await this.organizetiontree();
  }
  //组织数据
  async organizetiontree() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.organizetionData = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      detaillist.forEach((ele) => {
        if (ele.itemId == 13) {
          this.$data.transferType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 7) {
          this.$data.meterType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 8) {
          this.$data.applicationType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 3) {
          this.$data.ispType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 9) {
          this.$data.levelType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 14) {
          this.$data.controleType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 5) {
          this.$data.potocolType.push({ label: ele.name, value: ele.id });
        }
        if (ele.itemId == 17) {
          this.$data.deviceType.push({ label: ele.name, value: ele.id });
        }
      });
    }
    var devicew = JSON.parse(localStorage.getItem("devicewaringvalue"));
    if (devicew.length > 0) {
      devicew.forEach((ele) => {
        this.$data.deviceWaring.push({ label: ele.name, value: ele.id });
      });
    }
  }
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        if (this.meterModelPo.isSynch && (this.meterModelPo.sysnchDataPartion == null || this.meterModelPo.sysnchDataPartion == "")) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: "数据分区不能为空",
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
          this.loading = false;
          return;
        }
        if (
          this.meterModelPo.isSec == true &&
          this.meterModelPo.aesKey == null
        ) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: this.L("AesKey") + this.L("CanNotBeEmpty"),
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
          this.loading = false;
          return;
        }
        await this.$store
          .dispatch({
            type: "metermodel/create",
            data: this.meterModelPo,
          })
          .catch(() => {
            this.loading = false;
          });
        (this.$refs.meterModelForm as any).resetFields();
        this.meterModelPo = new meterModelPo();
        this.meterModelPo.isEnable = 1;
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  modelRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        type: "number",
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("Organization")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Name") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    transferType: [
      {
        required: true,
        type: "number",
        message:
          this.L("Transfer") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    meterType: [
      {
        required: true,
        type: "number",
        message: this.L("Meter") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    applicationId: [
      {
        required: true,
        type: "number",
        message:
          this.L("Application") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    priceId: [
      {
        type: "number",
        message: this.L("Price") + this.L("CanNotBeEmpty"),
        trigger: "change",
      },
    ],
    protocol: [
      {
        required: true,
        type: "number",
        message: this.L("Protocol") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "number",
        message: this.L("ISP") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    magnification: [
      {
        required: true,
        type: "number",
        message: this.L("Magnification") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    controleType: [
      {
        required: true,
        type: "number",
        message:
          this.L("Controle") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceType: [
      {
        required: true,
        type: "number",
        message: this.L("DeviceType") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceWaringValueId: [
      {
        type: "number",
        trigger: "blur",
      },
    ],
  };
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getPrice() {
    await this.$store
      .dispatch("price/getPriceList")
      .then((val) => {
        this.$data.price.push({ label: this.L("PleasChoose"), value: 0 });
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.price.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getSupplier() {
    await this.$store
      .dispatch("supplier/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.suppliers.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      transferType: [],
      meterType: [],
      applicationType: [],
      ispType: [],
      levelType: [],
      supplier: [],
      price: [],
      potocolType: [],
      controleType: [],
      suppliers: [],
      deviceType: [],
      deviceWaring: [],
      organizetionData: [],//组织
      warterMeterTypelist: [
        { value: 1, label: this.L('PhotoelectricDirectReading') },
        { value: 2, label: this.L('ColorCodeDirectReading') },
        { value: 3, label: this.L('CameraWaterMeter') },
        { value: 4, label: this.L('PulseWaterMter') },
        { value: 5, label: this.L('FullElectronicDirectReading') },
        { value: 6, label: this.L('PassiveThickFilm') },
      ],
      baudRatelist: [
        { value: 1, label: '1200' },
        { value: 2, label: '2400' },
        { value: 3, label: '4800' },
        { value: 4, label: '9600' },
        { value: 5, label: '19200' },
        { value: 6, label: '38400' },
      ],
      collectorportlist: [
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 6, label: 6 },
        { value: 7, label: 7 },
        { value: 8, label: 8 },
      ],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
